import { render, staticRenderFns } from "./HabitEdit.vue?vue&type=template&id=00cab186&"
import script from "./HabitEdit.vue?vue&type=script&lang=js&"
export * from "./HabitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports